import {gql} from '@apollo/client';
import {CAR_DETAIL_FRAGMENT, JOB_ROW_FRAGMENT, MICRO_JOB_ROW_FRAGMENT,MICRO_JOB_ROW_FRAGMENT_V2} from "../../common/graphqlQueries/fragments";


export const GET_JOB_LISTS_FOR_CITY_TEAM = gql`
    query jobListListingForCityTeam($page: Int, $search: String, $orderBy: String, $filters: [FilterInputType!], $workshopId: String!) {
        jobListListingForCityTeam(page: $page, search: $search, orderBy: $orderBy, filters: $filters, workshopId: $workshopId) {
            paginator{
                currentPage
                numPages
                totalItems
                perPage
            }
            search
            orderBy
            filters{
                key
            }
            data{
                id
                statusDisplay
                inspectionStatus
                car:refurbCar{
                    id
                    refurbCategory
                    car{
                      ...CarDetail
                    }
                }
                createdAt
                createdBy{
                    id
                    fullName
                }
            }
        }
    }
    ${CAR_DETAIL_FRAGMENT}
`;

export const GET_JOB_LIST = gql`
    query getJobList($jobListId: String!, $workshopId: String!) {
        getJobList(jobListId: $jobListId, workshopId: $workshopId){
            id
            isAssignmentDone
            car: refurbCar{
                id
                car{
                    ...CarDetail
                }
            }
            statusDisplay
            createdBy{
                id
                fullName
            }
            workshopRefurbCars{
                id
                workshop{
                    id
                    name
                    displayName
                }
                assignedCgt{
                    id
                    fullName
                }
            }
            jobRows{
                ...JobRow
                workshopJobrows{
                    workshop{
                        id
                        name
                        displayName
                    }
                    user{
                        fullName
                    }
                    status{
                        label
                        color
                        textStyle
                    }
                }
                isAssignableToWorkshop
                amount
            }
        }
    }
    ${JOB_ROW_FRAGMENT}
    ${CAR_DETAIL_FRAGMENT}
`;


export const ASSIGN_WORKSHOP_AND_CGT = gql`
    mutation assignToWorkshopAndCgt($data:AssignWorkshopAndCGTInput!, $workshopId: String!) {
        assignWorkshopAndCgt(data: $data, workshopId: $workshopId){
            success
            jobRows{
                ...JobRow
                workshopJobrows{
                    workshop{
                        id
                        name
                        displayName
                    }
                    user{
                        fullName
                    }
                    status{
                        label
                        color
                        textStyle
                    }
                }
                isAssignableToWorkshop
                amount
            }
        }
    }
    ${JOB_ROW_FRAGMENT}
`;

export const REASSIGN_WORKSHOP_AND_ADVISOR = gql`
    mutation reassignToWorkshopAndAdvisor($jobCardId: String!, $workshopId: String, $advisorUserId: String) {
        reassignAdvisorWorkshopJobCard(jobCardId: $jobCardId, workshopId: $workshopId, advisorUserId: $advisorUserId){
            workshopJobRowMapping{
                id
                workshop{
                    id
                    name
                    displayName
                }
                comment
                otherComment
                jobCard{
                    id
                    isAdvisorWorkshopReassignable
                    metaData{
                        advisors{
                            name
                        }
                    }
                }
                isApproved
                rejectedBy{
                    id
                    fullName
                }
            }
        }
    }
`;

export const GET_WORKSHOP_LIST = gql`
    query workshopList($isJobRowAssignable:Boolean) {
        workshopList(isJobRowAssignable: $isJobRowAssignable){
            id
            name
            displayName
        }
    }
`;

export const GET_JOB_CARD_DATA = gql`
    query getJobCard($refurbCarId:String!, $workshopId: String!) {
        getJobCardCityTeamV2(refurbCarId: $refurbCarId, workshopId: $workshopId){
            id
            car{
                ...CarDetail
              }
            workshopBayType{
              id
              name
              priority
            }
            jobRows{
              ...JobRow
            }
            refurbCar{
                id
                isBayLayoutEnabled
            }
            assignedTechnicianNameAndTime{
                label
            }
            workCompletedAt
            jobCard{
              microJobRows{
                ...MicroJobRow
                jobRow{
                    ...JobRow
                    isAcceptedByWorkshop
                }
                partDetails
                isVerifiable
                timeline{
                    label
                    color
                }
                images{
                    label
                    url
                }
              }
            }
        }
    }
    ${JOB_ROW_FRAGMENT}
    ${CAR_DETAIL_FRAGMENT}
    ${MICRO_JOB_ROW_FRAGMENT_V2}
`;

export const GET_JOB_CARD_JOB_ROW_DATA = gql`
    query getJobCard($jobCardId:String!) {
        getJobCard(id: $jobCardId){
            id
            workshop{
                id
                name
                displayName
            }
            metaData{
                advisors{
                    name
                }
            }
            jobRows(onlyApprovedJobRows: false){
                id
                isApproved
                rejectedBy{
                    id
                    fullName
                }
                jobRow{
                    ...JobRow
                }
            }
        }
    }
    ${JOB_ROW_FRAGMENT}
`;

export const GET_ADVISORS_FOR_WORKSHOP = gql`
    query getAdvisorsForWorkshop($workshopIds: [String!], $flatList: Boolean) {
        getAdvisorsForWorkshop(workshopIds: $workshopIds, flatList: $flatList){
            id
            fullName
        }
    }
`;

export const MARK_ASSIGNMENT = gql`
    mutation markAssign($jobListId: String!, $workshopId: String!) {
        markAssignment(jobListId: $jobListId, workshopId: $workshopId) {
            success
            jobList{
                id
                isAssignmentDone
                statusDisplay {
                    label
                    color
                }
                createdBy{
                    id
                    fullName
                }
            }
        }
    }
`;

export const GET_JOB_LISTS_FOR_REFURB_CAR = gql`
    query getJobListsForRefurbCar($refurbCarId: String!, $workshopId: String!) {
        getJobListsForRefurbCar(refurbCarId: $refurbCarId, workshopId: $workshopId){
            id
            isAssignmentDone
            car: refurbCar{
                id
                car{
                    ...CarDetail
                }
            }
            createdAt
            statusDisplay {
                workshopId
                name
                label
                color
            }
            createdBy{
                id
                fullName
            }
            workshopRefurbCars{
                id
                createdAt
                workshop{
                    id
                    name
                    displayName
                }
                assignedCgt{
                    id
                    fullName
                }
            }
            jobRows{
                ...JobRow
                workshopJobrows{
                    rejectionDetails{
                        rejectionComment
                        rejectionReason
                    }
                    workshop{
                        id
                        name
                        displayName
                    }
                    user{
                        fullName
                    }
                    status{
                        label
                        color
                        textStyle
                    }
                }
                isAssignableToWorkshop
                amount
                estimatePartCost
                estimateLabourCost
                inspectionMedia
            }
            journey{
                displayName
            }
        }
    }
    ${JOB_ROW_FRAGMENT}
    ${CAR_DETAIL_FRAGMENT}
`;